"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SvgFit = void 0;
var React = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconWrapper = _interopRequireWildcard(require("../../IconWrapper"));
var _excluded = ["title"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var SvgFit = function SvgFit(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId;
  return /*#__PURE__*/React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.282 19.536a.78.78 0 00.908 1.264l.093-.068 4.614-3.86-4.57-3.836a.78.78 0 00-1.085 1.115l.083.08 3.143 2.638-3.186 2.667zM13.615 20.634a.78.78 0 00-.014-1.018l-.083-.08-3.186-2.666 3.143-2.639a.78.78 0 00.164-1.005l-.067-.094a.78.78 0 00-1.006-.163l-.093.067-4.57 3.835 4.614 3.861a.78.78 0 001.098-.098z",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.333 15.887a.78.78 0 01.106 1.553l-.106.007H10.667a.78.78 0 01-.106-1.553l.106-.007h10.666zM6 9.887a.78.78 0 01.773.674l.007.106v12a.78.78 0 01-1.553.106l-.007-.106v-12c0-.431.35-.78.78-.78zM26 9.887a.78.78 0 01.773.674l.007.106v12a.78.78 0 01-1.553.106l-.007-.106v-12c0-.431.35-.78.78-.78z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};
exports.SvgFit = SvgFit;
SvgFit.propTypes = {
  title: _propTypes["default"].string,
  titleId: _propTypes["default"].string
};
var FitIcon = function FitIcon(_ref2) {
  var title = _ref2.title,
    props = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement(_IconWrapper["default"], props, /*#__PURE__*/React.createElement(SvgFit, {
    title: title || "Fit Icon",
    titleId: "SvgFit-Id"
  }));
};
FitIcon.propTypes = _IconWrapper.iconStylePropTypes;
var _default = FitIcon;
exports["default"] = _default;